const Divider = () => {
  return <div className='w-full h-2 mb-2 border-b-2 border-sub-100' />
}
export default Divider
